export class CourseEnrollmentService {
  /**
   * Calculates enrollment fees for a course
   * @param {Object} course - Course object
   * @returns {Object} Fee breakdown
   */
  static calculateEnrollmentFees(course) {
    const baseFee = course.baseFee ? course.baseFee : 0;
    const partnerBenefitEligible = course.payment?.partnerBenefitEligible;
    const partnerPayDiscount = partnerBenefitEligible ? baseFee : 0;
    const selfPayFee = 25; // Standard self-pay fee

    const fees = {
      baseFee,
      selfPayFee: partnerBenefitEligible ? selfPayFee : baseFee,
      partnerPayFee: baseFee - partnerPayDiscount,
      savings: partnerPayDiscount > 0 ? partnerPayDiscount : selfPayFee - baseFee
    };

    return fees;
  }

  /**
   * Formats course enrollment data for display
   * @param {Object} course - Course object
   * @returns {Object} Formatted course data
   */
  static formatCourseForDisplay(course) {
    const fees = this.calculateEnrollmentFees(course);
    // Backend now provides partnership warning flag directly in course.ui.shouldShowPartnerCoveredCourseWarning
    const hasPartnershipConflict = course.ui?.shouldShowPartnerCoveredCourseWarning || false;

    return {
      ...course,
      displayPrice: hasPartnershipConflict ? 'Free with benefits' : `$${fees.selfPayFee}`,
      enrollmentBadge: hasPartnershipConflict ? 'Partnership Available' : null,
      showPartnershipWarning: hasPartnershipConflict
    };
  }
}
